import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from 'react-native-reanimated';
import React, { useEffect } from 'react';
import { createStyles } from '@/contexts/theme-context';

const PULSE_DURATION_MS = 1000;
const MIN_OPACITY = 0.5;

interface Props {
  color: string;
  testID?: string;
}

export const PulsatingDot: React.FC<Props> = ({ color, testID }) => {
  const [styles] = useStyles();
  const animationProgress = useSharedValue(0);

  const animatedStyle = useAnimatedStyle(() => ({
    opacity: 1 - animationProgress.value * (1 - MIN_OPACITY),
  }));

  useEffect(() => {
    animationProgress.value = withRepeat(
      withTiming(1, { duration: PULSE_DURATION_MS }),
      -1,
      true,
    );
  }, [animationProgress]);

  return (
    <Animated.View
      style={[styles.dot, { backgroundColor: color }, animatedStyle]}
      testID={testID}
    />
  );
};

const useStyles = createStyles(() => ({
  dot: {
    borderRadius: 3,
    height: 6,
    width: 6,
  },
}));
